var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "交易单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderNo", $$v)
                                },
                                expression: "listPram.orderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商家订单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.merNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "merNo", $$v)
                                },
                                expression: "listPram.merNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "交易状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.payStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "payStatus", $$v)
                                },
                                expression: "listPram.payStatus",
                              },
                            },
                            _vm._l(_vm.offsetStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.userTypeDic.type == 5
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "下单小程序" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth ",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handerSearch },
                                  model: {
                                    value: _vm.listPram.appId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "appId", $$v)
                                    },
                                    expression: "listPram.appId",
                                  },
                                },
                                _vm._l(_vm.orderListWx, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.appName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.storeType
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "核销商家" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth ",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handleSelectedList },
                                  model: {
                                    value: _vm.listPram.offlineSupplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.listPram,
                                        "offlineSupplierId",
                                        $$v
                                      )
                                    },
                                    expression: "listPram.offlineSupplierId",
                                  },
                                },
                                _vm._l(_vm.formStoreSelect, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.supplierName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "核销门店" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.offlineStoreId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "offlineStoreId", $$v)
                                },
                                expression: "listPram .offlineStoreId",
                              },
                            },
                            _vm._l(_vm.formStoreSelectedOne, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "退款单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.refundNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "refundNo", $$v)
                                },
                                expression: "listPram.refundNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户手机号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "phone", $$v)
                                },
                                expression: "listPram.phone",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "退款时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth ",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.dataRenage,
                              callback: function ($$v) {
                                _vm.dataRenage = $$v
                              },
                              expression: "dataRenage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:offsetRefund:search"],
                          expression: "['admin:order:offsetRefund:search']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.handerSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:offsetRefund:export"],
                          expression: "['admin:order:offsetRefund:export']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary", disabled: _vm.isExporting },
                      on: { click: _vm.exportList },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.getExportButtonText()) +
                          "\n\t\t\t\t"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isExporting && !_vm.isInQueue
                    ? _c("el-progress", {
                        staticStyle: {
                          width: "200px",
                          display: "inline-block",
                          "vertical-align": "middle",
                          "margin-left": "10px",
                        },
                        attrs: {
                          percentage: _vm.exportProgress,
                          "stroke-width": 10,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isExporting && _vm.isInQueue
                    ? _c("el-progress", {
                        staticStyle: {
                          width: "200px",
                          display: "inline-block",
                          "vertical-align": "middle",
                          "margin-left": "10px",
                        },
                        attrs: {
                          percentage: 0,
                          "stroke-width": 10,
                          format: function (format) {
                            return _vm.currentQueuePosition > 0
                              ? "排队中 第" + _vm.currentQueuePosition + "位"
                              : "排队中..."
                          },
                          color: "#E6A23C",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "refundNo",
                  label: "退款单号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "交易单号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merNo",
                  label: "商家订单号",
                  "min-width": "260",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payAmount",
                  label: "消费金额",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierPrice",
                  label: "成本价",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.supplierPrice != null
                                ? "￥" +
                                    Number(scope.row.supplierPrice).toFixed(2)
                                : "-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "refundAmount",
                  label: "退款金额",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "refundReason",
                  label: "退款原因",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payStatusName",
                  label: "交易状态",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "startTimeStr",
                  label: "创建时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "endTimeStr",
                  label: "结束时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userInfo",
                  label: "用户下单",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "offlineStoreName",
                  label: "核销门店",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "核销方式", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              scope.row.verification === 1
                                ? "小程序"
                                : scope.row.verification === 2
                                ? "扫码枪"
                                : "未知"
                            ) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "offlineUserName",
                  label: "操作人",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:offsetRefund:view:detail"],
                                expression:
                                  "['admin:order:offsetRefund:view:detail']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisibleDetals,
            width: "35%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleDetals = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t交易订单号：" +
                    _vm._s(_vm.popupDetales.orderNo) +
                    "\n\t\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t商家单号：" +
                    _vm._s(_vm.popupDetales.merNo) +
                    "\n\t\t\t\t\t"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t用户流水号：" +
                    _vm._s(_vm.popupDetales.serialNo) +
                    "\n\t\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t交易发起时间：" +
                    _vm._s(_vm.popupDetales.startTimeStr) +
                    "\n\t\t\t\t\t"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t消费金额：" +
                    _vm._s(_vm.popupDetales.payAmount) +
                    "\n\t\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t交易完成时间：" +
                    _vm._s(_vm.popupDetales.endTimeStr) +
                    "\n\t\t\t\t\t"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t退款金额：" +
                    _vm._s(_vm.popupDetales.refundAmount) +
                    "\n\t\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t商品明细：" +
                    _vm._s(_vm.popupDetales.productInfo) +
                    "\n\t\t\t\t\t"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t下单用户：" +
                    _vm._s(_vm.popupDetales.userInfo) +
                    "\n\t\t\t\t\t"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _vm._v(
                  "\n\t\t\t\t\t核销门店：" +
                    _vm._s(_vm.popupDetales.offlineStoreName) +
                    "\n\t\t\t\t\t"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "min-height": "130px", "margin-bottom": "15px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                  _vm._v("核销凭证："),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                  _vm._l(
                    _vm.popupDetales.attachmentList,
                    function (item, index) {
                      return _c("el-image", {
                        key: index,
                        staticStyle: {
                          width: "100px",
                          height: "100px",
                          "margin-right": "10px",
                          "margin-bottom": "10px",
                          cursor: "pointer",
                        },
                        attrs: {
                          src: item,
                          "preview-src-list": _vm.previewImageList,
                        },
                      })
                    }
                  ),
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "15px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "10px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("退款日志")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "max-height": "200",
                        data: _vm.popupDetales.refundLogList,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          property: "desc",
                          label: "详情",
                          "min-width": "200",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          property: "time",
                          label: "时间",
                          width: "180",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleDetals = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }